import React from "react";
import { Button } from "@culturehq/components";
import { Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

import DefaultPromptModal from "./DefaultPromptModal";
import { DefaultPrompt } from "./DefaultPromptTypes";

interface DefaultPromptRowProps {
  defaultPrompt: DefaultPrompt;
  onUpdate: (defaultPrompt: DefaultPrompt) => void;
  onDelete: (defaultPrompt: DefaultPrompt) => void;
}

const DefaultPromptRow = ({ defaultPrompt, onUpdate, onDelete }: DefaultPromptRowProps) => {
  const { defaultInviter, prompt, imageUrl, note, createdAt, updatedAt } = defaultPrompt;

  return (
    <tr>
      <td>
        <Trans>{defaultInviter.name}</Trans>
      </td>
      <td>
        <Trans>{prompt.question}</Trans>
      </td>
      <td>
        <img className="StoryTable-Details__Image" src={imageUrl} alt="" />
      </td>
      <td>
        <Trans>{note}</Trans>
      </td>
      <td>
        <TimeDiff time={createdAt} />
      </td>
      <td>
        <TimeDiff time={updatedAt} />
      </td>
      <td className="Actions-column">
        <DefaultPromptModal defaultPrompt={defaultPrompt} onUpdate={onUpdate}>
          {(onTrigger: any) => (
            <Button icon="edit-outlined" onClick={onTrigger} inverted />
          )}
        </DefaultPromptModal>
        <ChqModalConfirmDelete
          onAccept={() => onDelete(defaultPrompt)}
          trigger={(onTrigger: any) => (
            <Button icon="trash-a-outlined" onClick={onTrigger} inverted />
          )}
        >
          <Trans>
            Are you sure you would like to delete this default prompt?
          </Trans>
        </ChqModalConfirmDelete>
      </td>
    </tr>
  );
};

export default DefaultPromptRow;
